var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "admin-user-tabs-shell" }, [
    _c(
      "nav",
      {
        staticClass: "admin-user-tabs",
        attrs: { "aria-label": _vm.trans("user.user") },
      },
      [
        _c("ul", { staticClass: "admin-user-tabs__list" }, [
          _c(
            "li",
            { staticClass: "admin-user-tabs__item-wrap" },
            [
              _c(
                "router-link",
                {
                  staticClass: "admin-user-tabs__link",
                  class: {
                    "admin-user-tabs__link--active": _vm.menu === "basic",
                  },
                  attrs: { to: `/user/${_vm.id}/basic` },
                },
                [
                  _c(
                    "span",
                    {
                      staticClass: "admin-user-tabs__icon",
                      attrs: { "aria-hidden": "true" },
                    },
                    [_c("admin-icon", { attrs: { name: "user" } })],
                    1
                  ),
                  _vm._v(" "),
                  _c("span", { staticClass: "admin-user-tabs__text" }, [
                    _vm._v(_vm._s(_vm.trans("user.basic"))),
                  ]),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "li",
            { staticClass: "admin-user-tabs__item-wrap" },
            [
              _c(
                "router-link",
                {
                  staticClass: "admin-user-tabs__link",
                  class: {
                    "admin-user-tabs__link--active": _vm.menu === "contact",
                  },
                  attrs: { to: `/user/${_vm.id}/contact` },
                },
                [
                  _c(
                    "span",
                    {
                      staticClass: "admin-user-tabs__icon",
                      attrs: { "aria-hidden": "true" },
                    },
                    [_c("admin-icon", { attrs: { name: "address-book" } })],
                    1
                  ),
                  _vm._v(" "),
                  _c("span", { staticClass: "admin-user-tabs__text" }, [
                    _vm._v(_vm._s(_vm.trans("user.contact"))),
                  ]),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "li",
            { staticClass: "admin-user-tabs__item-wrap" },
            [
              _c(
                "router-link",
                {
                  staticClass: "admin-user-tabs__link",
                  class: {
                    "admin-user-tabs__link--active": _vm.menu === "avatar",
                  },
                  attrs: { to: `/user/${_vm.id}/avatar` },
                },
                [
                  _c(
                    "span",
                    {
                      staticClass: "admin-user-tabs__icon",
                      attrs: { "aria-hidden": "true" },
                    },
                    [_c("admin-icon", { attrs: { name: "user" } })],
                    1
                  ),
                  _vm._v(" "),
                  _c("span", { staticClass: "admin-user-tabs__text" }, [
                    _vm._v(_vm._s(_vm.trans("user.avatar"))),
                  ]),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "li",
            { staticClass: "admin-user-tabs__item-wrap" },
            [
              _c(
                "router-link",
                {
                  staticClass: "admin-user-tabs__link",
                  class: {
                    "admin-user-tabs__link--active": _vm.menu === "social",
                  },
                  attrs: { to: `/user/${_vm.id}/social` },
                },
                [
                  _c(
                    "span",
                    {
                      staticClass: "admin-user-tabs__icon",
                      attrs: { "aria-hidden": "true" },
                    },
                    [_c("admin-icon", { attrs: { name: "share" } })],
                    1
                  ),
                  _vm._v(" "),
                  _c("span", { staticClass: "admin-user-tabs__text" }, [
                    _vm._v(_vm._s(_vm.trans("user.social"))),
                  ]),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.id != _vm.getAuthUser("id")
            ? _c(
                "li",
                { staticClass: "admin-user-tabs__item-wrap" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "admin-user-tabs__link",
                      class: {
                        "admin-user-tabs__link--active":
                          _vm.menu === "password",
                      },
                      attrs: { to: `/user/${_vm.id}/password` },
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "admin-user-tabs__icon",
                          attrs: { "aria-hidden": "true" },
                        },
                        [_c("admin-icon", { attrs: { name: "key" } })],
                        1
                      ),
                      _vm._v(" "),
                      _c("span", { staticClass: "admin-user-tabs__text" }, [
                        _vm._v(_vm._s(_vm.trans("user.reset_password"))),
                      ]),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.getConfig("email_template")
            ? _c(
                "li",
                { staticClass: "admin-user-tabs__item-wrap" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "admin-user-tabs__link",
                      class: {
                        "admin-user-tabs__link--active": _vm.menu === "email",
                      },
                      attrs: { to: `/user/${_vm.id}/email` },
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "admin-user-tabs__icon",
                          attrs: { "aria-hidden": "true" },
                        },
                        [_c("admin-icon", { attrs: { name: "mail" } })],
                        1
                      ),
                      _vm._v(" "),
                      _c("span", { staticClass: "admin-user-tabs__text" }, [
                        _vm._v(_vm._s(_vm.trans("user.email"))),
                      ]),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }